import React, { useEffect, useRef, useState } from 'react'
import FirstSection from './FirstSection'
import SecondSection from './SecondSection'
import VideoSection from './VideoSection'
import Testimonial from './Testimonial'
import Faq from './Faq'
import Contact from './Contact'
import classes from "./styles/Home.module.css";
import ProgramSection from './ProgramSection'
import { Helmet } from 'react-helmet'

const Home = () => {
  const lineRef = useRef(null);
  const lineRef2 = useRef(null);
  const [width, setWidth] = useState(0);
  const [width2, setWidth2] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!lineRef.current) return;

      const rect = lineRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Calculate the percentage scrolled relative to the element's top position
      if (rect.top <= viewportHeight && rect.bottom >= 0) {
        const scrolledDistance = viewportHeight - rect.top;
        const totalDistance = rect.height + viewportHeight;

        // Calculate width as a percentage
        const scrolledPercentage = Math.min(
          (scrolledDistance / totalDistance) * 100,
          100
        );

        setWidth(scrolledPercentage);
      } else {
        setWidth(0); // Reset width when out of view
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!lineRef2.current) return;

      const rect = lineRef2.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Calculate the percentage scrolled relative to the element's top position
      if (rect.top <= viewportHeight && rect.bottom >= 0) {
        const scrolledDistance = viewportHeight - rect.top;
        const totalDistance = rect.height + viewportHeight;

        // Calculate width as a percentage
        const scrolledPercentage = Math.min(
          (scrolledDistance / totalDistance) * 100,
          100
        );

        setWidth2(scrolledPercentage);
      } else {
        setWidth2(0); // Reset width when out of view
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  document.title = "Get Fit with Susmita | Online Fitness & Nutrition Coach"

  return (
    <div>
      <Helmet>
        <title>Get Fit with Susmita | Online Fitness & Nutrition Coach</title>
        <meta name="description" content="Transform your health with expert online fitness coaching and personalized nutrition plans. Train with Susmita, a certified coach, and achieve sustainable weight loss, strength, and energy—all from the comfort of your home. Book your free discovery call today!" />
      </Helmet>
      <div>
        <FirstSection/>
      </div>
      <div id='KnowYourCoachSection'>
      <SecondSection/>
      </div>
      <div id='ProgramSection'>
      <ProgramSection/>
      </div>
      <div
      ref={lineRef}
      className={classes.greenline}
      style={{ width: `${width}%` }}
    ></div>
      <div>
        <Testimonial/>
      </div>
      <div>
        <VideoSection/>
      </div>
      <div ref={lineRef2} className={classes.greenline2}
      style={{ width: `${width2}%` }}></div>
      <div id='FaqSection'>
        <Faq/>
      </div>
      <div id='DiscoveryCallSection'>
        <Contact/>
      </div>
    </div>
  )
}

export default Home
